import { Navigate } from 'react-router-dom';

import { paths } from 'src/routes/paths';
import { useUserStore } from 'src/stores/user/user.store';

type RoleBasedGuardProps = {
  permissions?: string;
  children: React.ReactNode;
};

export default function RoleBasedGuard({ permissions, children }: RoleBasedGuardProps) {
  const { userRole, permissionMap } = useUserStore();

  const permissionId = permissions ? Object.entries(permissionMap).find(([, value]) => value === permissions)?.[0] : null;

  const hasPermission = permissionId ? userRole.includes(permissionId) : false;

  if (!hasPermission) {
    return <Navigate to={paths.error.forbidden} replace />;
  }

  return <>{children}</>;
}
